<script>
import IconComponent from './Icon.vue'

let uuid = 0

export default {
    // state
    data () {
        return {
            id: uuid++,
        }
    },
    props: {
        value: String,
        display: String,
        label: String,
    },
    // misc.
    components: {
        Icon: IconComponent,
    },
}
</script>

<template>
    <div
        class="
            tw-flex
            tw-justify-between
            tw-items-center
            tw-px-4
            tw-py-2
            tw-bg-white
            tw-cursor-pointer
        "
    >
        <label
            class="tw-text-ccc"
            v-bind:class="{ 'tw-sr-only': value }"
            v-bind:for="'vac_date_input_' + id"
        >{{ label }}</label>
        <input
            class="tw-sr-only"
            type="date"
            v-bind:id="'vac_date_input_' + id"
            v-bind:value="value"
        />
        <strong
            aria-hidden="true"
            class="tw-font-normal"
        >{{ display }}</strong>
        <Icon
            class="tw-fill-999"
            aria-hidden="true"
            v-bind="{ icon: 'calendar' }"
        />
    </div>
</template>
